export default "__VITE_ASSET__DdS0iM$8__"